// project
import { camelToSentenceCase } from "@/utils/text";



export type TemplateParam = {
	label?:string;
	name:string;
	type:"number"|"string"|"boolean";
	subType?:"url"|"select"|"textarea";
	default?:any;
	stringOptions?:string[];
	validator?:ParamValidator;
};

export type HTMLTemplate = {
	icon?:string;
	label?:string;
	template:string|TemplateFactory;
	parameters:TemplateParam[];
};

export type TemplateContext = {
	template:HTMLTemplate;
	args:{ [k:string]:any };
};

export type TemplateFactory = (ctx:TemplateContext) => string;

export type ParamValidator = (v:any) => boolean;

export const image:HTMLTemplate = {
	icon:"mdi.image",
	parameters:[
		{
			label:"URL",
			name:"url",
			type:"string",
			// subType:"url"
		}
	],
	template:`<img style="width:100%" src="$url"/>`
};


export const video:HTMLTemplate = {
	icon:"mdi.play-circle-outline",
	parameters:[
		{
			label:"URL",
			name:"url",
			type:"string",
			// subType:"url"
		},
		{
			name:"preload",
			type:"boolean",
			default:true,
		},
		{
			name:"autoplay",
			type:"boolean",
			default:false,
		},
		{
			name:"loop",
			type:"boolean",
			default:false,
		}
	],
	template:`<video style="width:100%;"
	controls
	preload="$preload"
	autoplay="$autoplay"
	loop="$loop"
	src="$url"
	/>`
};

export const embeddedDocument:HTMLTemplate = {
	icon:"mdi.file-document",
	parameters:[
		{
			label:"URL",
			name:"url",
			type:"string",
			// subType:"url"
		}
	],
	template:`<embed src="$url" width="100%" height="600px" />`,
};

export const alertBox:HTMLTemplate = {
	icon:"mdi.information-outline",
	parameters:[
		{
			name:"type",
			type:"string",
			subType:"select",
			stringOptions:[ "info", "warning", "error" ],
			default:"info",
		},
		{
			name:"text",
			type:"string",
			subType:"textarea"
		}
	],

	template(ctx){

		const type = ctx.args["type"];

		const variant:string = ({
			"error":"danger"
		} as any)[type] || type;

		const icon = ({
			"info":"information-outline",
			"warning":"alert-outline",
			"error":"alert-outline",
		} as any)[type];

		return `<div class="p-3 border border-${variant} rounded font-weight-light">
		<span class="mdi mdi-${icon}"></span>
		<span class="ml-2">$text</span>
		</div>`;
	}
};

export const templates:{ [k:string]:HTMLTemplate } = {
	image,
	video,
	embeddedDocument,
	alertBox,
};


Object.keys(templates)
.forEach(tk => {
	templates[tk].label = templates[tk].label || camelToSentenceCase(tk);
})



const typeDefaults:any = {
	"string":"",
	"number":0,
	"boolean":false,
};



export const getTemplateContext = (tName:string):TemplateContext => {

	const template = templates[tName];

	const args:any = {};

	template.parameters.forEach(p => {
		args[p.name] = p.default || typeDefaults[p.type];
	});

	return {
		template,
		args
	}
};

export const processTemplate = (ctx:TemplateContext):string => {
	const t = ctx.template.template;
	const txt = typeof(t) === "function" ? t(ctx) : t;
	return replaceVars(txt, ctx.args);
};

const replaceVars = (s:string, values:{ [k:string]:any }) => {
	Object.keys(values)
	.forEach(k => s = s.replaceAll("$" + k, values[k]));
	return s.trim();
};